import { useCallback, useRef } from 'react'

/** Waits briefly before opening preview so double-click can cancel (e.g. for likes). */
export function useDeferredImageTapOpen(onOpenPreview: () => void, delayMilliseconds = 280) {
  const pendingTimeoutIdReference = useRef<ReturnType<typeof setTimeout> | null>(null)

  const scheduleDeferredOpen = useCallback(() => {
    if (pendingTimeoutIdReference.current) clearTimeout(pendingTimeoutIdReference.current)
    pendingTimeoutIdReference.current = setTimeout(() => {
      pendingTimeoutIdReference.current = null
      onOpenPreview()
    }, delayMilliseconds)
  }, [delayMilliseconds, onOpenPreview])

  const cancelDeferredOpen = useCallback(() => {
    if (pendingTimeoutIdReference.current) {
      clearTimeout(pendingTimeoutIdReference.current)
      pendingTimeoutIdReference.current = null
    }
  }, [])

  return { scheduleDeferredOpen, cancelDeferredOpen }
}
